import { laptopSmallMax, laptopSmallMin, laptopMaxXL } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { Box } from '../layout';
import { SmallHeading, SubHeading } from '../typography';

export const FeaturesContainer = styled.section<{ altBg?: boolean }>`
  padding: 85px 30px 115px 30px;
  background-color: ${({ theme, altBg }) => theme[altBg ? 'backgroundLightest' : 'white']};
`;

export const FeaturesWrapper = styled.div<{ maxW?: number }>`
  margin: 0 auto;
  max-width: ${({ maxW }) => maxW || 1080}px;
`;

export const FeaturesTitle = styled(SubHeading)`
  line-height: 1.3;
  color: ${({ theme }) => theme.primary};
`;

export const FeaturesSubtitle = styled(SmallHeading)`
  color: ${({ theme }) => theme.textDark};
  line-height: 1.5;
`;

export const FeaturesSectionContainer = styled.div<{
  align?: string;
  gap?: number;
  contentWidth?: number;
  reverse?: boolean;
  bp?: number;
}>`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'column' : 'column-reverse')};
  gap: 50px;

  @media (${({ bp }) => (bp ? `min-width: ${bp + 1}px` : laptopSmallMin)}) {
    gap: ${({ gap }) => gap || 30}px;
    flex-direction: row;
    align-items: ${({ align }) => align || 'center'};

    & > :nth-child(${({ reverse }) => (reverse ? 2 : 1)}) {
      ${({ contentWidth }) =>
        contentWidth != null
          ? css`
              flex: 1;
            `
          : css`
              flex-basis: 50%;
              width: 50%;
            `}
    }
    & > :nth-child(${({ reverse }) => (reverse ? 1 : 2)}) {
      flex-basis: ${({ contentWidth }) => (contentWidth != null ? `${contentWidth}px` : '50%')};
      width: ${({ contentWidth }) => (contentWidth != null ? `${contentWidth}px` : '50%')};
    }
  }

  @media (${({ bp }) => (bp ? `max-width: ${bp}px` : laptopSmallMax)}) {
    ${Box} {
      margin: 0 auto;
    }
  }
`;

export const FeaturesSectionImageContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FeaturesSectionImage = styled.img<{ maxW?: number; laptopMaxW?: number }>`
  width: 100%;
  ${({ maxW }) =>
    maxW != null
      ? css`
          max-width: ${maxW}px;
          margin: 0 auto;
        `
      : ''}

  ${({ laptopMaxW }) =>
    laptopMaxW != null
      ? css`
          @media (${laptopMaxXL}) {
            max-width: ${laptopMaxW}px;
          }
        `
      : ''}
`;

export const FeaturesSectionBgImage = styled.div<{ url: string; bgPosition?: string; mobMaxW?: number }>`
  background-image: url(${({ url }) => url});
  background-size: cover;
  background-position: ${({ bgPosition }) => bgPosition || '50%'};
  width: 100%;
  aspect-ratio: 1 / 1;

  ${({ mobMaxW }) =>
    mobMaxW != null
      ? css`
          @media (${laptopSmallMax}) {
            margin: 0 auto;
            max-width: ${mobMaxW}px;
          }
        `
      : ''}
`;

export const FeaturesSectionTitle = styled(SmallHeading)`
  color: ${({ theme }) => theme.textDark};
  line-height: 1.3;
`;

export const FeaturesSectionSubTitle = styled(SmallHeading)`
  line-height: 1.3;
`;

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  & > :not(:first-child) {
    margin-top: 15px;
  }
`;

export const FeaturesItem = styled.li`
  display: flex;
  flex-direction: row;
  gap: 12px;
  text-align: left;
  border-left: 3px solid ${({ theme }) => theme.primary};
  padding-left: 20px;

  svg {
    margin-top: 2px;
    font-size: 24px;
    color: ${({ theme }) => theme.primary};
  }

  p {
    flex: 1;
    line-height: 1.5;
  }
`;
